<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
/**
 * vuex管理登陆状态，具体可以参考官方登陆模板示例
 */
import {
	mapMutations
} from 'vuex'
export default {
	methods: {
		...mapMutations(['login'])
	},
	onLaunch: function () {
		const userInfo = uni.getStorageSync('userInfo') || ''
		if (userInfo.id && userInfo.status === 1) {
			// 更新登陆状态
			uni.getStorage({
				key: 'userInfo',
				success: (res) => {
					this.login(res.data)
				}
			})
		}

		// #ifdef MP-WEIXIN
		// 小程序更新管理器，仅在微信小程序环境下执行
		if (typeof uni.getUpdateManager === 'function') {
			const updateManager = uni.getUpdateManager()
			updateManager.onCheckForUpdate(function (res) {
				console.log('小程序版本检查', res.hasUpdate ? '有新版本' : '已是最新版本')
			})
			updateManager.onUpdateReady(function () {
				uni.showModal({
					title: '更新提示',
					content: '新版本已经准备好，是否重启应用？',
					success: function (res) {
						if (res.confirm) {
							updateManager.applyUpdate()
						}
					}
				})
			})
			updateManager.onUpdateFailed(function () {
				uni.showModal({
					title: '更新提示',
					content: '新版本下载失败，请删除当前小程序后重新搜索打开',
					showCancel: false
				})
			})
		}
		// #endif
	},
	onShow: function () {
		console.log('App Show')
	},
	onHide: function () {
		console.log('App Hide')
	}
}
</script>
<style lang='scss'>
@font-face {
	font-family: "yticon";
	src: url('~@/static/yticon.ttf') format('truetype');
}

/* =========================================
   禁止微信/系统字体缩放影响布局
   注意：不能设置 font-size: 16px !important，会破坏 rpx 计算
   ========================================= */

/* H5端 - 阻止浏览器/微信自动调整字体大小 */
html {
	-webkit-text-size-adjust: 100% !important;
	-moz-text-size-adjust: 100% !important;
	-ms-text-size-adjust: 100% !important;
	text-size-adjust: 100% !important;
}

body {
	-webkit-text-size-adjust: 100% !important;
	-moz-text-size-adjust: 100% !important;
	-ms-text-size-adjust: 100% !important;
	text-size-adjust: 100% !important;
}

/* 微信小程序/H5 通用 - 阻止字体缩放 */
page,
.uni-app,
.uni-page-body,
page-body {
	-webkit-text-size-adjust: 100% !important;
	text-size-adjust: 100% !important;
}

/* iOS微信字体放大问题 - 使用max-height限制 */
/* 注意：iOS微信会通过调整 line-height 来放大字体，需要限制 */
text,
view,
button,
navigator {
	-webkit-text-size-adjust: 100% !important;
	text-size-adjust: 100% !important;
}

page {
	background: #F5FAF2;
	--primary: #4CAF50;
	--primary-color: #66BB6A;
	--primary-light: #81C784;
	--primary-dark: #388E3C;
	--accent: #8BC34A;
	--accent-color: #9CCC65;
	--accent-light: #C5E1A5;
	--warm: #FF8F00;
	--warm-light: #FFB300;
	--gradient-primary: linear-gradient(135deg, #4CAF50 0%, #66BB6A 100%);
	--gradient-accent: linear-gradient(135deg, #8BC34A 0%, #C5E1A5 100%);
	--gradient-warm: linear-gradient(135deg, #FF8F00 0%, #FFB300 100%);
	--bg-light: #F8FCF6;
	--bg-card: #FFFFFF;
	--text-primary: #2D2D2D;
	--text-secondary: #7B7B7B;
	--text-muted: #9CA3AF;
	--border-color: #E0ECD8;
	--shadow-sm: 0 2rpx 8rpx rgba(76, 175, 80, 0.08);
	--shadow-md: 0 4rpx 16rpx rgba(76, 175, 80, 0.12);
	--shadow-lg: 0 8rpx 32rpx rgba(76, 175, 80, 0.16);
}

:root {
	--primary: #4CAF50;
	--primary-color: #66BB6A;
	--primary-light: #81C784;
	--primary-dark: #388E3C;
	--accent: #8BC34A;
	--accent-color: #9CCC65;
	--accent-light: #C5E1A5;
	--warm: #FF8F00;
	--warm-light: #FFB300;
	--gradient-primary: linear-gradient(135deg, #4CAF50 0%, #66BB6A 100%);
	--gradient-accent: linear-gradient(135deg, #8BC34A 0%, #C5E1A5 100%);
	--gradient-warm: linear-gradient(135deg, #FF8F00 0%, #FFB300 100%);
	--bg-light: #F8FCF6;
	--bg-card: #FFFFFF;
	--text-primary: #2D2D2D;
	--text-secondary: #7B7B7B;
	--text-muted: #9CA3AF;
	--border-color: #E0ECD8;
	--shadow-sm: 0 2rpx 8rpx rgba(76, 175, 80, 0.08);
	--shadow-md: 0 4rpx 16rpx rgba(76, 175, 80, 0.12);
	--shadow-lg: 0 8rpx 32rpx rgba(76, 175, 80, 0.16);
}

.keyboard-popup {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 9999;
}

.mask {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
}

.yticon {
	font-family: "yticon" !important;
	font-size: 16px;
	font-style: normal;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

.icon-iconfontshanchu1:before {
	content: "\e619";
}

.icon-iconfontweixin:before {
	content: "\e611";
}

.icon-alipay:before {
	content: "\e636";
}

.icon-shang:before {
	content: "\e624";
}

.icon-shouye:before {
	content: "\e626";
}

.icon-shanchu4:before {
	content: "\e622";
}

.icon-xiaoxi:before {
	content: "\e618";
}

.icon-jiantour-copy:before {
	content: "\e600";
}

.icon-fenxiang2:before {
	content: "\e61e";
}

.icon-pingjia:before {
	content: "\e67b";
}

.icon-daifukuan:before {
	content: "\e68f";
}

.icon-pinglun-copy:before {
	content: "\e612";
}

.icon-dianhua-copy:before {
	content: "\e621";
}

.icon-shoucang:before {
	content: "\e645";
}

.icon-xuanzhong2:before {
	content: "\e62f";
}

.icon-gouwuche_:before {
	content: "\e630";
}

.icon-icon-test:before {
	content: "\e60c";
}

.icon-icon-test1:before {
	content: "\e632";
}

.icon-bianji:before {
	content: "\e646";
}

.icon-jiazailoading-A:before {
	content: "\e8fc";
}

.icon-zuoshang:before {
	content: "\e613";
}

.icon-jia2:before {
	content: "\e60a";
}

.icon-huifu:before {
	content: "\e68b";
}

.icon-sousuo:before {
	content: "\e7ce";
}

.icon-arrow-fine-up:before {
	content: "\e601";
}

.icon-hot:before {
	content: "\e60e";
}

.icon-lishijilu:before {
	content: "\e6b9";
}

.icon-zhengxinchaxun-zhifubaoceping-:before {
	content: "\e616";
}

.icon-naozhong:before {
	content: "\e64a";
}

.icon-xiatubiao--copy:before {
	content: "\e608";
}

.icon-shoucang_xuanzhongzhuangtai:before {
	content: "\e6a9";
}

.icon-jia1:before {
	content: "\e61c";
}

.icon-bangzhu1:before {
	content: "\e63d";
}

.icon-arrow-left-bottom:before {
	content: "\e602";
}

.icon-arrow-right-bottom:before {
	content: "\e603";
}

.icon-arrow-left-top:before {
	content: "\e604";
}

.icon-icon--:before {
	content: "\e744";
}

.icon-zuojiantou-up:before {
	content: "\e605";
}

.icon-xia:before {
	content: "\e62d";
}

.icon--jianhao:before {
	content: "\e60b";
}

.icon-weixinzhifu:before {
	content: "\e61a";
}

.icon-comment:before {
	content: "\e64f";
}

.icon-weixin:before {
	content: "\e61f";
}

.icon-fenlei1:before {
	content: "\e620";
}

.icon-erjiye-yucunkuan:before {
	content: "\e623";
}

.icon-Group-:before {
	content: "\e688";
}

.icon-you:before {
	content: "\e606";
}

.icon-forward:before {
	content: "\e607";
}

.icon-tuijian:before {
	content: "\e610";
}

.icon-bangzhu:before {
	content: "\e679";
}

.icon-share:before {
	content: "\e656";
}

.icon-yiguoqi:before {
	content: "\e997";
}

.icon-shezhi1:before {
	content: "\e61d";
}

.icon-fork:before {
	content: "\e61b";
}

.icon-kafei:before {
	content: "\e66a";
}

.icon-iLinkapp-:before {
	content: "\e654";
}

.icon-saomiao:before {
	content: "\e60d";
}

.icon-shezhi:before {
	content: "\e60f";
}

.icon-shouhoutuikuan:before {
	content: "\e631";
}

.icon-gouwuche:before {
	content: "\e609";
}

.icon-dizhi:before {
	content: "\e614";
}

.icon-fenlei:before {
	content: "\e706";
}

.icon-xingxing:before {
	content: "\e70b";
}

.icon-tuandui:before {
	content: "\e633";
}

.icon-zuanshi:before {
	content: "\e615";
}

.icon-zuo:before {
	content: "\e63c";
}

.icon-yiguoqi1:before {
	content: "\e700";
}

.icon-shoucang2:before {
	content: "\e62e";
}

.icon-shouhuodizhi:before {
	content: "\e712";
}

.icon-yishouhuo:before {
	content: "\e71a";
}

.icon-dianzan-ash:before {
	content: "\e617";
}

view,
scroll-view,
swiper,
swiper-item,
cover-view,
cover-image,
icon,
text,
rich-text,
progress,
button,
checkbox,
form,
input,
label,
radio,
slider,
switch,
textarea,
navigator,
audio,
camera,
image,
video {
	box-sizing: border-box;
}

/* 骨架屏替代方案 */
.Skeleton {
	background: #f3f3f3;
	padding: 20upx 0;
	border-radius: 8upx;
}

/* 图片载入替代方案 */
.image-wrapper {
	font-size: 0;
	background: #f3f3f3;
	border-radius: 4px;

	image {
		width: 100%;
		height: 100%;
		transition: .6s;
		opacity: 0;

		&.loaded {
			opacity: 1;
		}
	}
}

.clamp {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	display: block;
}

.common-hover {
	background: #f5f5f5;
}

/*边框*/
.b-b:after,
.b-t:after {
	position: absolute;
	z-index: 3;
	left: 0;
	right: 0;
	height: 0;
	content: '';
	transform: scaleY(.5);
	border-bottom: 1px solid $border-color-base;
}

.b-b:after {
	bottom: 0;
}

.b-t:after {
	top: 0;
}

/* button样式改写 */
uni-button,
button {
	height: 80upx;
	line-height: 80upx;
	font-size: $font-lg + 2upx;
	font-weight: normal;

	&.no-border:before,
	&.no-border:after {
		border: 0;
	}
}

uni-button[type=default],
button[type=default] {
	color: $font-color-dark;
}

/* input 样式 */
.input-placeholder {
	color: #9CA3AF;
}

.placeholder {
	color: #9CA3AF;
}
</style>